'use client'

import type { ImageProps } from 'next/image'
import Image from 'next/image'
import { memo, startTransition, useState } from 'react'

import { cx } from '../../cx'
import { Skeleton } from '../skeleton/skeleton'

export type LoadingImageProps = ImageProps & {
  reduceTransitions?: boolean
  ref?: React.Ref<HTMLImageElement>
}

export const LoadingImage = memo(function LoadingImage({
  ref,
  className,
  reduceTransitions,
  ...props
}: LoadingImageProps) {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div className="relative size-full">
      <Skeleton
        animate={reduceTransitions ? 'none' : 'pulse'}
        className={cx(
          'absolute',
          !reduceTransitions && 'transition-opacity duration-300',
          isLoading ? 'opacity-100' : 'hidden opacity-0'
        )}
      />

      <Image
        onLoad={() => {
          startTransition(() => setIsLoading(false))
        }}
        ref={ref}
        className={cx(
          !reduceTransitions && 'transition-opacity duration-300',
          isLoading ? 'opacity-0' : 'opacity-100',
          className
        )}
        {...props}
      />
    </div>
  )
})
